Vue.use(VueBus);

import VueWorker from "vue-worker";
Vue.use(VueWorker);

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

import {
    Add,
    Sub,
    Mul,
    Div,
    // toFixed,
    // toFixedFloor,
    // toFixedFloorExtend,
    on,
    off
} from "./../../common/ts/share";

import { Decimal } from "decimal.js";

//四舍五入
function toFixed(n) {
  var number = this;
  var result = new Decimal(number).toFixed(n);
  return result;
}
//非四舍五入向下取值，保留n位小数
function toFixedFloor(n) {
  var number = this;
  var result = new Decimal(number).toFixed(n, Decimal.ROUND_DOWN);
  return result;
}
//非四舍五入向下取值，保留n位小数 功能同上，由于老代码历史问题，故保留了名字不通，名称相同的代码
function toFixedFloorExtend(n) {
  var number = this;
  var result = new Decimal(number).toFixed(n, Decimal.ROUND_DOWN);
  return result;
}



Math.add = Add;
Math.sub = Sub;
Math.mul = Mul;
Math.div = Div;
Number.prototype.toFixed = String.prototype.toFixed = toFixed;
Vue.filter("toFixed", function(val, n) {
    return toFixed.call(val, n);
});
Number.prototype.toFixedFloor = String.prototype.toFixedFloor = toFixedFloor;
Vue.filter("toFixedFloor", function(val, n) {
    return toFixedFloor.call(val, n);
});
Number.prototype.toFixedFloorExtend = String.prototype.toFixedFloorExtend = toFixedFloorExtend;
Vue.filter("toFixedFloorExtend", function(val, n) {
    return toFixedFloorExtend.call(val, n);
});

window.on = Element.prototype.on = on;
window.off = Element.prototype.off = off;

//过滤器
Vue.filter("format", function(val = "", reg = "MM/DD hh:mm") {
    //避免显示 NAN
    if (!val) return "";
    let timeLocal = "";
    switch (window.localeLanguage) {
        case "zh_CH":
            break;
        case "zh_TW":
            break;
        case "en_US":
            timeLocal = "(UTC+8)";
            reg = reg.replace("月", "-").replace("日", "");
            break;
        case "ko_KR":
            timeLocal = "(UTC+8)";
            reg = reg.replace("月", "-").replace("日", "");
            break;
    }
    return miment(Date.parse(val.replace(/-/g, "/"))).format(reg) + timeLocal;
});

//涨幅 ‘+/-’数字过滤
/***
 * val 当前值
 */
Vue.filter("positive", function(val = 0) {
    return val > 0 ? "+" + val : val;
});

//国际化组件
import cmLang from "@/components/Lang";
Vue.component("Lang", cmLang);

//图标组件
import Icon from "@/components/Icon";
Vue.component("Icon", Icon);

//svg组件
import "@/icons";
//效果同于 Vue.component('svg-icon', SvgIcon)



// WEBPACK FOOTER //
// ./src/assets/js/vue.extends.js